import { pushEventInfo, setPageDetails } from '../analytics';
var BASE = 'account>linked accounts';
var MAML = 'maml:linked accounts';
var MY_ACCOUNT = 'account';
/**
 * Page analtyics for linked accounts
 */
export var setLinkedAccountsPageAnalytics = function () {
    var linkedAccountsPageData = {
        pageInfo: {
            pageName: BASE,
            pageType: MAML,
        },
        category: {
            primaryCategory: MY_ACCOUNT,
            subCategory1: BASE,
            subCategory2: BASE,
        },
    };
    setPageDetails(linkedAccountsPageData);
};
export var linkedAccountRedirectAnalytics = function (redirectToDetails) {
    var thdAnalyticsEvent = {
        category: {
            primaryCategory: 'stash',
        },
        eventInfo: {
            eventName: 'my account settings',
            eventMode: 'stash',
        },
        stash: {
            myAccount: {
                settings: "family accounts: child ".concat(redirectToDetails ? 'account details link' : 'purchase history link'),
            },
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
